import {InputGroup, Card, Col, Container, Form, Row, Button, Spinner, Alert} from "react-bootstrap";
import {useAuth} from "../components/auth/AuthProvider";
import {useState} from "react";
import {changePassword} from "../lib/api/changePassword";
import {reject_codes} from "../lib/api/api_errors";

function ProfilePage() {

    const {token, username} = useAuth();
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [passwordErrors, setPasswordErrors] = useState({
        currentPasswordError: "",
        newPasswordError: "",
        confirmPasswordError: "",
    });
    const [passwordForm, setPasswordForm] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const onSaveData = (e) => {}

    const _resetErrors = () => {
        setPasswordErrors({
            currentPasswordError: "",
            newPasswordError: "",
            confirmPasswordError: "",
        })
    }

    const _setPasswordError = (name, value) => {
        setPasswordErrors((prev) => ({ ...prev, [name]: value }));
    }

    const _resetPasswordForm = () => {
        setPasswordForm({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
        })
    }

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordForm((prev) => ({ ...prev, [name]: value }));
        _resetErrors();
    }

    const onChangePassword = (e) => {
        e.preventDefault();
        setSaving(true);

        if (passwordForm.newPassword.length === 0) {
            _setPasswordError("newPasswordError", "Password is required")
            return;
        }

        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            _setPasswordError("newPasswordError", "Password does not match with confirm password")
            return;
        }

        changePassword(token, username, passwordForm.currentPassword, passwordForm.newPassword).then(() => {
            setSuccess("Password changed successfully.");
            _resetPasswordForm();
        }).catch((error_code) => {
            if (error_code === reject_codes.UNAUTHORIZED) {
                _setPasswordError("currentPasswordError", "Wrong password");
            }
            else if (error_code === reject_codes.VALIDATION_FAILED) {
                _setPasswordError("newPasswordError", "Wrong format");
            }
            else {
                setError("Internal API Error")
            }
        }).finally( () => {
            setSaving(false);
        })
    };



    return (
        <Container>
            {error && (
                <Alert
                    variant="danger"
                    dismissible
                    onClose={() => setError("")}
                    className="mb-3"
                >
                    {error}
                </Alert>
            )}
            {success && (
                <Alert
                    variant="success"
                    dismissible
                    onClose={() => setSuccess("")}
                    className="mb-3"
                >
                    {success}
                </Alert>
            )}
            <Card className="border-primary mb-4">
                <Card.Header as="h5">User Profile</Card.Header>
                <Card.Body>

                    <Row className="mb-2">
                        <Col>
                            <a href="#" onClick={() => {window.history.go(-1); return false;}}>&lt;-- Back</a>
                        </Col>
                    </Row>

                    <Row>
                        <Form onSubmit={onSaveData}>
                            <Row className="mb-2">
                                <Form.Group className="mb-3" controlId="fullName">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        name="username"
                                        type="text"
                                        value={username}
                                        disabled={true}

                                    />
                                    <Form.Control.Feedback type="invalid">Please enter your name.</Form.Control.Feedback>
                                </Form.Group>

                            </Row>
                        </Form>
                    </Row>

                    <Row>
                        <Card className="border-primary mb-4">
                            <Card.Header as="h6">Change password</Card.Header>
                            <Card.Body>
                                <Form className="d-flex align-items-center gap-2" onSubmit={onChangePassword}>
                                    <InputGroup>
                                        <InputGroup.Text>Current password</InputGroup.Text>
                                        <Form.Control
                                            name="currentPassword"
                                            type="password"
                                            required
                                            isInvalid={passwordErrors.currentPasswordError}
                                            onChange={handlePasswordChange}
                                            value={passwordForm.currentPassword}

                                        />
                                        <Form.Control.Feedback type="invalid">{passwordErrors.currentPasswordError}</Form.Control.Feedback>
                                    </InputGroup>

                                    <InputGroup>
                                        <InputGroup.Text>New password</InputGroup.Text>
                                        <Form.Control
                                            name="newPassword"
                                            type="password"
                                            required
                                            isInvalid={passwordErrors.newPasswordError}
                                            onChange={handlePasswordChange}
                                            value={passwordForm.newPassword}
                                        />
                                        <Form.Control.Feedback type="invalid">{passwordErrors.newPasswordError}</Form.Control.Feedback>
                                    </InputGroup>

                                    <InputGroup>
                                        <InputGroup.Text>Confirm password</InputGroup.Text>
                                        <Form.Control
                                            name="confirmPassword"
                                            type="password"
                                            requied
                                            isInvalid={passwordErrors.confirmPasswordError}
                                            onChange={handlePasswordChange}
                                            value={passwordForm.confirmPassword}
                                        />
                                        <Form.Control.Feedback type="invalid">{passwordErrors.confirmPasswordError}</Form.Control.Feedback>
                                    </InputGroup>

                                    <Button type="submit" variant="primary" disabled={saving}>
                                        {saving ? <Spinner size="sm" animation="border" /> : "Change"}
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Row>




                </Card.Body>
            </Card>
        </Container>

    )
}

export default ProfilePage;